// src/components/Elements/Modal/Modal.jsx
import React, { useEffect, useId, useState } from "react";
import { Modal as ResponsiveModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import "./Modals.css";

const Modal = ({
  id,
  display,
  title,
  size = "large",
  children,
  fullMobile = false,
  hiddeCloseButton = false,
  onClose,
  titleVariant = "modal-title",
  headerClassName = "modal-header",
  onCloseCallback,
}) => {
  const defaultId = useId();
  const [containerClass, setContainerClass] = useState("");
  const [wrapperClass, setWrapperClass] = useState("");

  useEffect(() => {
    setContainerClass(
      `modal-container-wrapper ${fullMobile ? "modal-full-mobile" : ""}`
    );
    setWrapperClass(`modal-wrapper modal-size-${size}`);
  }, [size, fullMobile]);

  const handleClose = () => {
    onClose(false);
    if (onCloseCallback) setTimeout(onCloseCallback, 0);
  };

  return (
    <ResponsiveModal
      modalId={id || defaultId}
      open={display}
      onClose={handleClose}
      center
      showCloseIcon={!hiddeCloseButton}
      closeIcon={<span className="modal-close-icon">×</span>}
      classNames={{
        modal: wrapperClass,
        overlay: "modal-overlay",
        modalContainer: containerClass,
      }}
    >
      {title && (
        <div className={headerClassName}>
          <h2 className={titleVariant}>{title}</h2>
        </div>
      )}
      <div className="modal-body">{children}</div>
    </ResponsiveModal>
  );
};

export default Modal;
